import * as deviceRequests from './devices';
import * as playlistRequests from './playlists';
import * as userRequests from './user';
import * as moduleTypeRequests from './moduleTypes';
import * as searchRequests from './search';
import * as faqRequests from './faqs';
import * as assetsOverrideRequests from './assetsOverride';

export default {
    ...deviceRequests,
    ...playlistRequests,
    ...userRequests,
    ...moduleTypeRequests,
    ...searchRequests,
    ...faqRequests,
    ...assetsOverrideRequests,
};
